/**
 * @typedef {JQuery | jQuery} JQ
 */

/**
 *
 * @type {Map<JQ, {[id: string]: {tab: JQ, items: JQ}}>}
 */
const cache = new Map();

/**
 *
 * @param {JQ} container
 * @param {function(JQ): [JQ, string, JQ]} buildCacheCb
 * @param {function(JQ, boolean): void} hideCb
 * @param {function(boolean): void} noMatchesCb
 * @return {function(function(JQ): boolean)}
 */
export function getFilter(container, buildCacheCb, hideCb, noMatchesCb = () => {}) {
    return (cb) => {
        filter(container, hideCb, buildCacheCb, cb, noMatchesCb);
    };
}

/**
 *
 * @param {JQ} container
 * @param {function(JQ, boolean): void} hideCb
 * @param {function(JQ): [JQ, string, JQ]} buildCacheCb
 * @param {function(boolean): void} noMatchesCb
 * @param {function(JQ): boolean} cb
 */
function filter(container, hideCb, buildCacheCb, cb, noMatchesCb) {
    if (!cache.has(container)) {
        const c = {};
        container.find('.tab-pane').each(function () {
            const [tab, id, items] = buildCacheCb($(this));
            c[id] = {
                tab,
                items
            };
        });
        cache.set(container, c);
    }

    let firstValidTab;
    Object.values(cache.get(container)).forEach(data => {
        let visibleItems = data.items.length;
        data.items.each(function () {
            const visible = cb($(this));
            hideCb($(this), visible);
            if (!visible) {
                visibleItems--;
            }
        });

        data.tab.toggleClass('tab-header-disabled', visibleItems === 0);
        if (!firstValidTab && visibleItems > 0) {
            firstValidTab = data.tab;
        }
    });

    if (!firstValidTab) {
        noMatchesCb(true);
        return;
    }

    noMatchesCb(false);
    firstValidTab?.trigger('click');
}